/**
 * Helper function to detect is current code running in browser
 */
const isBrowser = (): boolean => ![typeof window, typeof document].includes("undefined");

export default isBrowser;
